import { TypeFormRendering } from './typeFormRendering.js'
import { typeFormPropsNps } from './typeFormsProps.js'

const RenderTypeForms = () => {
  const typeFormsByHierarchy = [TypeFormRendering(typeFormPropsNps)]
  return typeFormsByHierarchy.find(research => research.show)?.component || ''
}

export default RenderTypeForms
